/** Linhas geradas pelo sistema em clientes.observacao (não são notas do usuário). */

const MERGE_LINE_RE = /^\[(.+?)\]\s+Unificação de cliente:\s+/;
const HYGIENE_LINE_RE = /^\[Higienização\s+/;

export function isSystemObservacaoLine(line) {
  const s = String(line || "").trim();
  if (!s) return false;
  return MERGE_LINE_RE.test(s) || HYGIENE_LINE_RE.test(s);
}

/**
 * Separa notas editáveis do histórico automático (merge / higienização).
 */
export function splitClientObservacao(raw) {
  const lines = String(raw || "").split("\n");
  const auditLines = [];
  const userLines = [];

  for (const line of lines) {
    const trimmed = String(line || "").trim();
    if (!trimmed) continue;
    if (isSystemObservacaoLine(trimmed)) {
      auditLines.push(trimmed);
    } else {
      userLines.push(line.replace(/\r$/, ""));
    }
  }

  return {
    userNotes: userLines.join("\n").trim(),
    auditLines,
  };
}

/** Recompõe o valor persistido em clientes.observacao. */
export function mergeClientObservacaoForSave(userNotes, auditLines = []) {
  const notes = String(userNotes || "").trim();
  const audit = (auditLines || []).map((l) => String(l || "").trim()).filter(Boolean);
  if (!notes && !audit.length) return "";
  if (!notes) return audit.join("\n");
  if (!audit.length) return notes;
  return `${notes}\n${audit.join("\n")}`;
}

/** Formata uma linha de auditoria para exibição na UI. */
export function formatObservacaoAuditEntry(line) {
  const s = String(line || "").trim();
  const mergeM = s.match(/^\[(.+?)\]\s+Unificação de cliente:\s+(.*)$/);
  if (mergeM) {
    let details = null;
    try {
      details = mergeM[2] ? JSON.parse(mergeM[2]) : null;
    } catch {
      details = null;
    }
    const secId = details?.secondary?.id;
    const primId = details?.primary?.id ?? details?.primaryId;
    const secName = details?.secondary?.nome;
    const who = details?.by;
    let title = "Unificação de cadastros";
    if (secId != null && primId != null) {
      title = `Cliente #${secId}${secName ? ` (${secName})` : ""} unificado em #${primId}`;
    }
    return {
      type: "merge",
      date: mergeM[1],
      title,
      subtitle: who ? `Por ${who}` : "Unificação automática",
    };
  }

  const hygieneM = s.match(/^\[Higienização\s+(.+?)\]\s+(.*)$/);
  if (hygieneM) {
    return {
      type: "hygiene",
      date: hygieneM[1],
      title: hygieneM[2],
      subtitle: "Higienização de cadastro",
    };
  }

  return {
    type: "system",
    date: null,
    title: s.length > 120 ? `${s.slice(0, 117)}…` : s,
    subtitle: "Registro do sistema",
  };
}

export function parseObservacaoAuditEntries(auditLines = []) {
  return auditLines.map(formatObservacaoAuditEntry);
}
